import React, { useState, Fragment } from 'react';
import Picture from '../../Picture';
import './GenericFAQ.scss';

const GenericFAQ = ({
  title = "Perguntas frequentes",
  faqItems = [],
  defaultOpenIndex = null,
  containerClassName = "generic-faq-container",
  itemClassName = "generic-faq-item",
  questionClassName = "generic-faq-question",
  answerClassName = "generic-faq-answer",
  arrowIconSrc = "/images/site/recursos/arrow-down.svg",
  headerLightbulbIconSrc = "/images/site/recursos/pedidos-ia/faq-lightbulb.png",
  isAIPage
}) => {
  const [activeIndex, setActiveIndex] = useState(defaultOpenIndex);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (!faqItems || faqItems.length === 0) {
    return null;
  }

  const TitleComponent = isAIPage ? 'p' : 'h2';

  return (
    <div className={containerClassName}>
      <div className="generic-faq-header">
        <div className="generic-faq-title-wrapper">
          <TitleComponent className="generic-faq-title">{title}</TitleComponent>
        </div>
        <div className="generic-faq-header-icon-wrapper">
          <div className="generic-faq-header-icon-overlap">
            <div className="generic-faq-header-icon-ellipse" />
            {headerLightbulbIconSrc ? (
              <Picture className="generic-faq-header-icon-image" src={headerLightbulbIconSrc} alt="FAQ Icon" />
            ) : (
              <div className="generic-faq-header-icon-text">💡</div>
            )}
          </div>
        </div>
      </div>

      {faqItems.map((item, index) => (
        <div className={itemClassName} key={index}>
          <div className="generic-faq-divider" />
          <button
            className={`${questionClassName} ${activeIndex === index ? 'active' : ''}`}
            onClick={() => toggleAccordion(index)}
            aria-expanded={activeIndex === index}
            aria-controls={`faq-answer-${index}`}
          >
            <span className="generic-faq-question-text">{item.question}</span>
            <Picture
              className="generic-faq-arrow-icon"
              alt="Expandir/recolher"
              src={arrowIconSrc}
            />
          </button>
          <div
            id={`faq-answer-${index}`}
            className={`${answerClassName} ${activeIndex === index ? 'active' : ''}`}
          >
            {typeof item.answer === 'string' ? <div dangerouslySetInnerHTML={{ __html: item.answer }} /> : item.answer}
          </div>
        </div>
      ))}
    </div>
  );
};

export default GenericFAQ;


// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/custom/GenericFAQ.jsx